import { render } from "./m-prediction-sumary-view.vue?vue&type=template&id=9b30810e&scoped=true&ts=true"
import script from "./m-prediction-sumary-view.vue?vue&type=script&lang=ts"
export * from "./m-prediction-sumary-view.vue?vue&type=script&lang=ts"

import "./m-prediction-sumary-view.vue?vue&type=style&index=0&id=9b30810e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b30810e"]])

export default __exports__